import React from 'react';

const Intro = () => {
	return (
		<article className='App_content_about' data-matching-link='about-link'>
			<h2 className='App_content-title'>Shawn Losovoj</h2>
			<i className='App_content-title'>Software Engineer | Frontend Architect</i>
			<i className='App_content-title'>Migration Specialist | Technical Consultant</i>
			<p>
				I'm a technology enthusiast and software engineer who believes in crafting solutions that
				make people's business and personal lives easier. My skill set is adaptable to meet your
				needs and get the job done. My Code is built with both clean practices & modularity, and
				with the end-user in mind for responsiveness & accessibility.
			</p>

			<hr></hr>
		</article>
	);
};

export default Intro;
